import axios from 'axios';
import { showTabs, selectTab } from '../../common/tab/tabActions';
import consts from '../../consts';
import { setErroAPI, setSuccess } from '../../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../../common/dateFormat/DateFormat';
import FormatUtils from '../../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'COLABORADOR_MODO_TELA',
        payload: {
			modo: modo,
			registro: {
				...registro,
				area: FormatUtils.formatarValorTela(registro.area, 2)
			}
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('colaboradorForm', {
			...registro,
			area: FormatUtils.formatarValorTela(registro.area, 2)
		})
    ];
}

export function setAguardando(aguardando) {
    return {
        type: 'COLABORADOR_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista(id_produtor) {
    const request = axios.get(`${consts.API_URL}/pessoa?id_pessoa_tipo=2&id_produtor=${id_produtor}`);
    return {
        type: 'COLABORADOR_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/pessoa`, {
				...registro,
				cpf: FormatUtils.removerMascara(registro.cpf),
				telefone: FormatUtils.removerMascara(registro.telefone),
				area: FormatUtils.formatarValorBanco(registro.area, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_produtor));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/pessoa`, {
				...registro,
				cpf: FormatUtils.removerMascara(registro.cpf),
				telefone: FormatUtils.removerMascara(registro.telefone),
				area: FormatUtils.formatarValorBanco(registro.area, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_produtor));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/pessoa?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(registro.id_produtor));
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaEspecie() {
    const request = axios.get(`${consts.API_URL}/especie/listarSelect`);
    return {
        type: 'COLABORADOR_ESPECIE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaColaboradorRegime() {
    const request = axios.get(`${consts.API_URL}/colaboradorRegime/listarSelect`);
    return {
        type: 'COLABORADOR_REGIME_SELECT_LISTADO',
        payload: request
    };
}